var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"tag-text"},[_vm._v(_vm._s(_vm.strArr[0]))]),_c('span',{staticClass:"tag-id"},[_vm._v("ID:"+_vm._s(_vm.strArr[1]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }